//FlyersOnTheWall.jsx 
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
// import MainLayout from '../../layouts/MainLayout';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';

const FlyersOnTheWall = () => {

  const location = useLocation();
  // console.log("Location in FlyersList ", location);
  const authState = useSelector(state => state.authReducer);
  // const { bookId, bookTitle, ownerId, ownerName } = location.state;

  const [flyers, setFlyers] = useState([]);
  const [fetchData, { loading }] = useFetch();
  const [userId, setUserId] = useState(authState.user._id);
  const [fromPage, setFromPage] = useState(location.state.fromPage);
  const [bookId, setBookId] = useState(location.state.bookId);
  const [bookTitle, setBookTitle] = useState(location.state.bookTitle);
  const [ownerId, setOwnerId] = useState(location.state.ownerId);
  const [ownerName, setOwnerName] = useState(location.state.ownerName);

  const [selectedFlyerId, setSelectedFlyerId] = useState(null);
  const [selectedRecordId, setSelectedRecordId] = useState(null);

  const fetchFlyers = useCallback(() => {
    const config = {
      url: "/flyonwall/myflyers",
      method: "get",
      headers: { Authorization: authState.token },
      params: { bookId, ownerId }
    };

    fetchData(config, { showSuccessToast: false })
      .then(data => {
        // console.log("received data : ", data);
        if (data && Array.isArray(data.flyOnTheWall)) {
          setFlyers(data.flyOnTheWall);
        } else {
          console.error("Invalid response format: Flyers not found in response!");
        }
      })
      .catch(error => {
        console.error('Error fetching Flyers:', error);
      });
  }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchFlyers();
  }, [authState.isLoggedIn, fetchFlyers]);

  //   useEffect(() => {
  //     console.log("Flyers:", flyers);
  // }, [flyers]);


  const handleView = (flyerId) => {
    setSelectedFlyerId(prevId => (prevId === flyerId ? null : flyerId));
  };

  const handleComments = (id) => {
    setSelectedRecordId(id);
  };

  const handleCommentSave = (id) => {
    setSelectedRecordId(id);
  };

  const formatDate = (date) => {
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatDateTime = (date) => {
    const options = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

  const sortedFlyers = [...flyers].sort((a, b) => b.flyerName - a.flyerName);

  return (
    <div className='bg-black text-white [&_p]:text-white p-2'>
      <div className="min-h-screen">
       <h3 className='text-xl font-bold text-yellow-200 text-center mb-4'>BookShelf - Flyers On The Wall</h3>
        <div className="border border-gray-300 p-4 mt-4">
          <div className="flex justify-between items-center bg-gray-600">
            <div className='text-lg mt-1 text-white'>
              <p className='text-yellow-300' >There are <strong>{flyers.length}</strong> Flyers On The Wall for: </p>
              {bookTitle !== 'All' && <p className='text-lg mt-1 text-white'>{bookTitle} </p>}
            </div>
          </div>
          {loading ? (
            <Loader />
          ) : (
            <div>
              {flyers.length === 0 ? (
                <div className='min-h-[100vh] flex items-center justify-center gap-4 text-yellow-300'>
                  <span>No record found!!</span>
                </div>
              ) : (
                sortedFlyers.map((flyer, index) => (
                  <div key={flyer._id} className='bg-gray-600 text-white my-1 p-4 rounded-md shadow-md'>
                    <div className='flex'>
                      <span className='font-medium'>{index + 1}. {flyer.flyerName}</span>
                      <Tooltip text={"View details"} position={"top"}>
                        <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleView(flyer._id)}>
                          <i className="fa-solid fa-eye"></i>
                        </span>
                      </Tooltip>
                    </div>
                    {selectedFlyerId === flyer._id && (
                      <div className='bg-gray-600 text-white'>
                        <div>
                          <div>
                            <p><strong>Flyer On The Wall:</strong> {flyer.flyerName}</p>
                            <p><strong>Date:</strong> {formatDateTime(flyer.dateCreated)}</p>
                            <p><strong>Is Allowed:</strong> {flyer.isAllowed ? "Yes" : "No"}</p>
                            <p><strong>Flying On The Wall For Books:</strong></p>
                            <p>{flyer.bookTitle}</p>
                          </div>
                          <div>
                            <div>
                              {flyer && flyer.comments && flyer.comments.length > 0 && (
                                <div>
                                  <p className='text-blue-500'><strong>Comments:</strong></p>
                                  {flyer.comments.map((comment, commentIndex) => (
                                    <div key={commentIndex} className={commentIndex % 2 === 0 ? 'bg-blue-100' : ''}>
                                      <p><strong>{comment.commentBy}</strong></p>
                                      <p>{new Date(comment.date).toLocaleString()}</p>
                                      <p>{comment.comment}</p>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )} 
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default FlyersOnTheWall;
